// Инициализация разрешений из роутов
import { routes } from 'core/router/routes';

export const generatePermissionsFromRoutes = () => {
  const routePermissions = routes
    .filter((route) => route.isShowMenu === true && !route.adminOnly && !route.allRoles)
    .map((route) => ({
      title: route.label || '',
      name: route.path.replace('/', ''),
    }));

  // Добавляем специальное разрешение для Яндекс сервисов
  const yandexPermission = {
    title: 'Яндекс',
    name: 'yandex',
  };

  return [...routePermissions, yandexPermission];
};
